import React, { useState } from 'react'
import cn, { Argument as ClassName } from 'classnames'
import styled from 'styled-components'

import Text from '../../ui/Text'

const SWrapper = styled.div`
    display: flex;
    font-size: 14px;
    font-weight: 400;

    @media (max-width: 900px) {
        justify-content: space-between;
    }
`

const SResult = styled.a<{ selected: boolean }>`
    display: inline-block;
    color: ${({ selected, theme }) => (selected ? theme.font.darkestColor : theme.brandColors.CA_Blue)};
    text-decoration: ${({ selected }) => (selected ? 'underline' : 'none')};
    cursor: pointer;
    font-weight: 500;

    &:not(last-of-type) {
        padding-left: 10px;
    }

    &:hover {
        color: ${({ theme, selected }) => (selected ? theme.font.darkestColor : theme.brandColors.CA_Blue)};
        opacity: ${({ selected }) => (selected ? 1 : 0.5)};
        text-decoration: ${({ selected }) => (selected ? 'underline' : 'none')};
    }
`

enum NumberOfItems {
    twenty = 20,
    fifty = 50,
    hundred = 100,
}

const RESULTS_PER_PAGE = [NumberOfItems.twenty, NumberOfItems.fifty, NumberOfItems.hundred]

export type ResultsPerPageProps = {
    dataTestid: string
    onSelectNumberOfItems: (result: NumberOfItems) => void
    className?: ClassName
    style?: React.CSSProperties
}

export function ResultsPerPage({
    className,
    style,
    onSelectNumberOfItems,
    dataTestid,
}: ResultsPerPageProps): React.ReactElement {
    const [selectedNumberOfItems, setSelectedNumberOfItems] = useState(NumberOfItems.twenty)

    return (
        <SWrapper className={cn(className)} style={style}>
            <Text code="lblResultsPerPage" />:{' '}
            <div data-testid={dataTestid}>
                {RESULTS_PER_PAGE.map((numberOfItems) => (
                    <SResult
                        key={numberOfItems}
                        selected={selectedNumberOfItems === numberOfItems}
                        onClick={() => {
                            onSelectNumberOfItems(numberOfItems)
                            setSelectedNumberOfItems(numberOfItems)
                        }}
                        data-testid={`number${numberOfItems}`}
                    >
                        {numberOfItems}
                    </SResult>
                ))}
            </div>
        </SWrapper>
    )
}
